import {
  NORMAL_COLOR_VALUE,
  ESCALATED_COLOR_VALUE,
  MODERATE_COLOR_VALUE,
  timeType,
  TIME_RANGE
} from './constants';

export const calculateBgColor = (value, minThreshold, maxThreshold) => {
  return value <= minThreshold
    ? NORMAL_COLOR_VALUE
    : value >= maxThreshold
    ? ESCALATED_COLOR_VALUE
    : MODERATE_COLOR_VALUE;
};

export const getDefaultTimeRangeValue = (): timeType =>
  (parseInt(localStorage.getItem('defaultTimeRange')) as timeType) ||
  TIME_RANGE['60'];

// Alert thresholds are stored as JSON, e.g. {"key": {"op": value}} or
// [{"key": {"op": value}}, ...], but the DB value is itself wrapped as a
// quoted string with internal quotes doubled (e.g. `"[{ ""status""...`) -
// undo that wrapping before parsing.
const THRESHOLD_TIME_UNIT_KEYS = ['durationAvg', 'responseTime'];

const formatThresholdCondition = (key: string, value: unknown): string => {
  if (Array.isArray(value)) {
    const nested = value
      .flatMap((item) => Object.entries(item as Record<string, unknown>))
      .map(([nestedKey, nestedValue]) =>
        formatThresholdCondition(nestedKey, nestedValue)
      )
      .join(', ');
    return `${key}: ${nested}`;
  }
  if (value && typeof value === 'object') {
    const [operator, operand] =
      Object.entries(value as Record<string, unknown>)[0] ?? [];
    return `${key} ${operator} ${operand}`;
  }
  return `${key} ${value}`;
};

export const formatThreshold = (raw: string): string => {
  if (!raw) return '';
  try {
    const cleaned =
      raw.startsWith('"') && raw.endsWith('"')
        ? raw.slice(1, -1).replace(/""/g, '"')
        : raw;
    const parsed = JSON.parse(cleaned);
    const entries: Record<string, unknown>[] = Array.isArray(parsed)
      ? parsed
      : [parsed];
    const description = entries
      .flatMap((entry) =>
        Object.entries(entry).map(([key, value]) =>
          formatThresholdCondition(key, value)
        )
      )
      .join(' and ');
    const usesTimeUnit = entries.some((entry) =>
      Object.keys(entry).some((key) => THRESHOLD_TIME_UNIT_KEYS.includes(key))
    );
    return usesTimeUnit ? `${description} seconds` : description;
  } catch {
    return raw;
  }
};
